'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _hooks = require('./utils/hooks');

var _hooks2 = _interopRequireDefault(_hooks);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var target = document.getElementsByTagName('script')[0] || document.head;
var count = 0; // 记录id
var timeout = 60000; // jsonp超时时间60s

var Jsonp = function () {
    function Jsonp() {
        (0, _classCallCheck3.default)(this, Jsonp);

        this.script = null; // 调用jsonp创建的script
        this.timer = null; // 计时器
        this.id = '__jsonp' + count;
        count += 1;
    }

    (0, _createClass3.default)(Jsonp, [{
        key: 'start',
        value: function start(url, params) {
            // 获取该网络请求编号
            this.hookData = {
                url: url,
                data: params
            };
            this.url = url;
            return _hooks2.default.beforeSendHook({
                netRequest: this.send,
                hookData: this.hookData,
                params: url + this.dealData(params),
                target: this,
                requestType: 'jsonp'
            });
        }
    }, {
        key: 'dealData',
        value: function dealData(params) {
            params.callback = this.id;
            return '?' + _utils2.default.reverseParams(params);
        }
    }, {
        key: 'cleanup',
        value: function cleanup() {
            if (this.script.parentNode) {
                this.script.parentNode.removeChild(this.script);
            }
            window[this.id] = function () {};
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }, {
        key: 'send',
        value: function send(url) {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var that = _this;
                window[_this.id] = function (data) {
                    that.cleanup();
                    // 网络请求结束的钩子
                    resolve({
                        idNo: _this.idNo,
                        requestType: 'jsonp',
                        params: _this.hookData,
                        json: data
                    });
                };
                _this.timer = setTimeout(function () {
                    that.cleanup();
                    reject(new Error(that.url + 'Timeout'));
                }, timeout);
                _this.script = document.createElement('script');
                _this.script.src = url;
                target.parentNode.insertBefore(_this.script, target);
            });
        }
    }]);
    return Jsonp;
}();

exports.default = Jsonp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/node_modules/@souche-f2e/http-request/dist/jsonp.js
// module id = h2dH
// module chunks = 11